import React from 'react';
import styled from 'styled-components';

import { Row, Col, Container } from '../Grid';
import { boxShadow, gridGapSize } from '../lib/styles/helpers';
import { timeSince } from '../lib/time';

const messageGap = 8;

const MessageRow = styled(Row)`
  padding-bottom: ${messageGap / 2}px;
  padding-top: ${messageGap / 2}px;
`;
const MessageBox = styled.div`
  background-color: #fff;
  ${boxShadow}
`;
const MessageContainer = styled(Container)`
  padding: ${gridGapSize}px;
`;
const Wrapper = styled.div`
  display: flex;
`
const ProfileImageWrapper = styled.div`
  border-radius: 50%;
  display: block;
  height: 42px;
  margin-right: ${gridGapSize}px;
  overflow: hidden;
  width: 42px;
`;
const ProfileImage = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;
const InfoText = styled.div`
  flex-grow: 1;
`;
const Author = styled.div`
  font-size: 14px;
  line-height: 1.5;
`;
const TimeRemaining = styled.div`
  color: #999999;
  font-size: 12px;
  line-height: 1.4;
`
const MessageText = styled.p`
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
`;

const Message = (props) => {
  return (
    <MessageRow>
      <Col>
        <MessageBox>
          <MessageContainer>
            <Wrapper>
              <ProfileImageWrapper>
                <ProfileImage
                  src={`https://message-list.appspot.com${props.message.author.photoUrl}`}
                  alt={props.message.author.name}
                />
              </ProfileImageWrapper>
              <InfoText>
                <Author>
                  {props.message.author.name}
                </Author>
                <TimeRemaining>
                  {timeSince(props.message.updated)} ago
                </TimeRemaining>
              </InfoText>
            </Wrapper>
            <MessageText>
              {props.message.content}
            </MessageText>
          </MessageContainer>
        </MessageBox>
      </Col>
    </MessageRow>
  );
};

export default Message;



// WEBPACK FOOTER //
// ./src/Messages/MessageCard.js